import React from 'react';
import CameraInfo, { getCameraInfoDisplayValue } from './CameraInfo';
import style from '../style.module.scss';

const ONVIF_ROWS = [
  { label: 'Make & Model', section: 'device' },
  { label: 'Resolution', section: 'resolution' },
  { label: 'Encoding', section: 'encodingType' },
  { label: 'Bitrate', section: 'bitrate' },
  { label: 'FPS', section: 'fps' },
  { label: 'GOP', section: 'gop' },
  { label: 'Sharpness', section: 'sharpness' },
  { label: 'Saturation', section: 'saturation' },
  { label: 'Brightness', section: 'brightness' },
  { label: 'Contrast', section: 'contrast' },
  { label: 'Focus Mode', section: 'autoFocusMode' },
  { label: 'White Balance Mode', section: 'whiteBalanceMode' },
  { label: 'WB CrGain', section: 'whiteBalanceCrGain' },
  { label: 'WB CbGain', section: 'whiteBalanceCbGain' },
];

const CameraInfoRow = ({ cameras }) => (
  <>
    {ONVIF_ROWS.map(({ label, section }) => {
      const values = cameras.map((c) => getCameraInfoDisplayValue(c.cameraSettings, section));
      const hasMismatch = new Set(values).size > 1;
      return (
        <tr
          key={section}
          className={`${style.TopLabel} ${hasMismatch ? style.rowMismatch : ''}`.trim()}
        >
          <td className={style.SideLabel}>{label}</td>
          {cameras.map((camera) => (
            <td key={camera._id}>
              <CameraInfo cameraSettings={camera.cameraSettings} section={section} />
            </td>
          ))}
        </tr>
      );
    })}
  </>
);

export default CameraInfoRow;

